import {$post, $get} from '../utils/request'



export const $uploadCert=async(params)=>{
    console.log("base64上传文件开始")
   
    

    let res=await $post('ajaxUploadBase64.do',params);
    console.log(res)
    console.log("base64上传文件结束")
    return res;
}

//查询老师信息列表
export const $teacherList=async(params)=>{
    console.log("查询老师信息开始")
    
    console.log(params)
    let res=await $post('teacherList.do',params);
    console.log("查询老师信息结束")
    return res;
}


/**
 * 
 * @param {新增老师} params 
 * @returns 
 */
export const $submitTeacher= async(params)=>{
    console.log("提交老师信息开始")
   
    console.log(params)
    let res=await $post('submitTeacher.do',params);
    console.log(res)
    console.log("提交老师信息结束")
    return res;
}



/**
 * 
 * @param {根据id查询老师} params 
 * @returns 
 */
export const $getTeacher= async(params)=>{
    console.log("根据id查询老师开始")
  
    console.log(params)
    let res=await $post('getTeacher.do',params);
    console.log(res)
    console.log("根据id查询老师结束")
    return res;
}




/**
 * 
 * @param {删除老师} params 
 * @returns 
 */
export const $deleteTeacher= async(params)=>{
    let res=await $post('deleteTeacher.do',params);
    return res;
}

/**
 * 
 * @param {查询擅长} params 
 * @returns 
 */
export const $getGoodAt=async(params)=>{
    
    let res=await $post('getGoodAt.do',params);
    return res;
}